import { apiGet, apiPost } from '../utils/apiClient';

export default class ErrorsConfigIntegration {
    listErrorsConfig(agendaApiUrl, templateId, authToken) {
        return apiGet(`${agendaApiUrl}/error/${templateId}`, { authToken });
    }

    getAllErrorCodes(agendaApiUrl, templateId, authToken) {
        return apiGet(`${agendaApiUrl}/error/${templateId}/ErrorCodes`, { authToken });
    }

    postErrorsConfig(agendaApiUrl, templateId, templateErrorsConfig, authToken) {
        return apiPost(
            `${agendaApiUrl}/error/${templateId}`,
            templateErrorsConfig,
            { authToken }
        ).then(() => ({ success: true }));
    }
}
